var _defs, _path, _rect, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LinkedInIconLayer",
    "data-name": "LinkedIn Icon Layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 39.55 39.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .linkedin-icon-cls-1{fill:url(#linkedin-linear-gradient);}.linkedin-icon-cls-2{fill:url(#linkedin-linear-gradient-2);}.linkedin-icon-cls-3{fill:url(#linkedin-linear-gradient-3);}.linkedin-icon-cls-4{fill:none;stroke-miterlimit:10;stroke-width:3px;stroke:url(#linkedin-linear-gradient-4);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-linear-gradient",
    x1: 40.74,
    y1: 42.92,
    x2: 44.84,
    y2: 42.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5ac3b2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#29b8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-linear-gradient-2",
    x1: 10.55,
    y1: 22.34,
    x2: 14.65,
    y2: 22.34,
    xlinkHref: "#linkedin-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-linear-gradient-3",
    x1: 46.79,
    y1: 52.77,
    x2: 59.2,
    y2: 52.77,
    xlinkHref: "#linkedin-linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkedin-linear-gradient-4",
    x1: 0,
    y1: 19.77,
    x2: 39.55,
    y2: 19.77,
    xlinkHref: "#linkedin-linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linkedin-icon-cls-1",
    d: "M44.84,42.92a1.93,1.93,0,0,1-2.05,2,2,2,0,0,1-2-1.94,2.08,2.08,0,0,1,2-2.16A2,2,0,0,1,44.84,42.92Z",
    transform: "translate(-30.2 -30.33)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "linkedin-icon-cls-2",
    x: 10.55,
    y: 15.67,
    width: 4.1,
    height: 13.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "linkedin-icon-cls-2",
    d: "M54.69,46.2a4.48,4.48,0,0,0-3.9,2h-.1l-.21-1.74H46.79c0,1.13.1,2.46.1,4v8.82H51V52.05a3.28,3.28,0,0,1,.1-1,2.2,2.2,0,0,1,1.95-1.64c1.43,0,2.05,1.23,2.05,2.87v7.08h4.1V51.74C59.2,48,57.25,46.2,54.69,46.2Z",
    transform: "translate(-30.2 -30.33)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "linkedin-icon-cls-4",
    x: 1.5,
    y: 1.5,
    width: 36.55,
    height: 36.55,
    rx: 12.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.244896c1012e9210f7bda7542810d4f3.svg";
export { ForwardRef as ReactComponent };